import { RouteLocationNormalizedLoaded, RouteLocationNormalized } from 'vue-router';
import { getEnableFirstRoute } from '@/utils/getEnableFirstRoute';
import { tutorialsRoutes } from '@/modules/tutorials/router/tutorials';
import { useBrandComponent } from '@/composables/useBrandComponent';

const MainRoutes = {
    path: '/private',
    meta: {
        requiresAuth: true
    },
    redirect: (_to: RouteLocationNormalized) => {
        // Calcular la ruta habilitada dinámicamente cuando se accede a la ruta
        const routeName = getEnableFirstRoute();
        return { name: routeName };
    },
    component: () => import('@/layouts/full/FullLayout.vue'),
    children: [
        {
            path: 'user',
            name: 'Usuario',
            redirect: { name: 'Profile' },
            children: [
                {
                    path: 'profile',
                    name: 'Profile',
                    component: useBrandComponent('views/private/user/profile/Profile.vue'),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'profile' }
                }
            ]
        },
        // {
        //     path: 'dashboard',
        //     name: 'Mi Tablero',
        //     redirect: { name: 'dashboard-main' },
        //     children: [
        //         {
        //             name: 'dashboard-main',
        //             path: 'main',
        //             component: () => import('@/views/private/dashboard/dashboard2.vue'),
        //             meta: { requiresPermission: 'brokerin', minLevel: 20 }
        //         }
        //     ]
        // },
        {
            path: 'dashboard',
            name: 'Mi Tablero',
            redirect: { name: 'dashboard-main-2' },
            children: [
                {
                    name: 'dashboard-main-2',
                    path: 'main',
                    // component: () => import('@/views/private/dashboard/dashboard1.vue'),
                    component: useBrandComponent('views/private/dashboard/dashboard1.vue'),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_board' }
                }
            ]
        },
        {
            path: 'sales',
            name: 'Ventas',
            redirect: { name: 'Mis Ventas' },
            children: [
                {
                    name: 'Mis Ventas',
                    path: 'list',
                    component: useBrandComponent('views/private/sales/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        searchInput: route.query.searchInput || '',
                    }),
                    meta: { requiresPermission: '', minLevel: 20, requiresSystemPermission: '' }
                },               
            ]
        },
        {
            path: 'activity',
            name: 'Actividades',
            redirect: { name: 'Mis Folios' },
            children: [
                {
                    path: 'list',
                    name: 'Mis Folios',
                    component: useBrandComponent('views/private/activity/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        searchInput: route.query.searchInput || '',
                        status: route.query.status || null,
                        sub_status: route.query.sub_status || null,
                        movementType: route.query.movementType || null,
                        movementCategory: route.query.movementCategory || null,
                        insurance_id: route.query.insurance_id || null,
                        subcategoryId: route.query.subcategoryId || null,
                        filterRageDates: route.query.filterRageDates || null,
                        alert: route.query.alert || null,
                        rag: route.query.rag || null,
                        model: route.query.model || null,
                        pending_status: route.query.pending_status || null
                    }),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_folios' }
                },
                {
                    path: 'detail/:activity_id',
                    name: 'Detalle de Actividad',
                    component: () => import('@/views/private/activity/DetailV2.vue'),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_folios' }
                },
                {
                    path: 'detail/v2/:hash_folio',
                    name: 'Detalle de la Actividad',
                    component: () => import('@/views/private/activity/DetailV2.vue'),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_folios' }
                }
            ]
        },
        {
            path: 'quote',
            name: 'Cotizaciones',
            redirect: { name: 'Mis Cotizaciones' },
            children: [
                {
                    name: 'Mis Cotizaciones',
                    path: 'list',
                    component: () => import('@/views/private/activity/ListOt.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        searchInput: route.query.searchInput || '',
                        status: route.query.status || null,
                        movementType: '10',
                        insurance_id: route.query.insurance_id || null,
                        subcategoryId: route.query.sub_category_id || null,
                        filterRageDates: route.query.filterRageDates || null,
                        alert: route.query.alert || null,
                        model: ''
                    }),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'quote_by_work_order' }
                }
            ]
        },
        {
            path: 'policy',
            name: 'Polizas',
            redirect: { name: 'Mis Pólizas' },
            children: [
                {
                    name: 'Mis Pólizas',
                    path: 'list',
                    component: () => import('@/views/private/policy/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        searchInput: route.query.searchInput || '',
                        client_hash: route.query.client_hash || '',
                        insurance_id: route.query.insurance_id || '',
                        filterRageDates: route.query.filterRageDates || null,
                        date_field: route.query.date_field || '',
                        payment_status: route.query.payment_status || null,
                        renovation_status: route.query.renovation_status || null,
                        policy_status: route.query.policy_status || null,
                        kind: route.query.kind || null,
                        sub_category_id: route.query.sub_category_id || null,
                        attachment: route.query.attachment || null,
                        category_type: route.query.category_type || ''
                    }),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_policies' }
                },
                {
                    name: 'Editar Póliza',
                    path: 'edit/:hash/:isPylc(0|1)?',
                    component: () => import('@/views/private/policy/Edit.vue'),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_policies' }
                }
            ]
        },
        {
            path: 'client',
            name: 'Clientes',
            redirect: { name: 'Mis Clientes' },
            children: [
                {
                    name: 'Mis Clientes',
                    path: 'list',
                    component: () => import('@/views/private/client/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        searchInput: route.query.searchInput || ''
                    }),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_clients' }
                },
                {
                    name: 'Editar Cliente',
                    path: 'edit/:client_hash',
                    component: () => import('@/views/private/client/Edit.vue'),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_clients' }
                }
            ]
        },
        {
            path: 'emission',
            name: 'Emisiones',
            redirect: { name: 'Mi Tablero' },
            children: [
                {
                    path: 'edit/:policy_hash',
                    name: 'Editar Emisión',
                    component: () => import('@/views/private/emission/Edit.vue')
                },
                {
                    path: 'agency/:policy_hash',
                    name: 'Editar Emisión Agencia',
                    component: () => import('@/views/private/emission/agency/Edit.vue')
                }
            ]
        },
        {
            path: 'multiquote',
            name: 'Multicotizador',
            redirect: { name: 'Mi Tablero' },
            children: [
                {
                    path: 'auto',
                    name: 'Autos Online',
                    component: () => import('@/views/private/multiquote/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        categoryId: '1',
                        subCategoryId: '4',
                        movementType: '10',
                        searchInput: route.query.searchInput || '',
                        status: route.query.status || null,
                        model: 'multi_quote'
                    })
                },
                {
                    path: 'rc_contratista',
                    name: 'RC Contratista Online',
                    component: () => import('@/views/private/multiquote/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        categoryId: '3',
                        subCategoryId: '49',
                        movementType: '10',
                        searchInput: route.query.searchInput || '',
                        status: route.query.status || null,
                        model: 'multi_quote'
                    })
                },
                {
                    path: 'gmm',
                    name: 'GMM Online',
                    component: () => import('@/views/private/multiquote/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        categoryId: '2',
                        subCategoryId: '15',
                        movementType: '10',
                        searchInput: route.query.searchInput || '',
                        status: route.query.status || null,
                        model: 'multi_quote'
                    })
                },
                {
                    path: 'camiones_individual',
                    name: 'Camiones Online',
                    component: () => import('@/views/private/multiquote/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        categoryId: '1',
                        subCategoryId: '6',
                        movementType: '10',
                        searchInput: route.query.searchInput || '',
                        status: route.query.status || null,
                        model: 'multi_quote'
                    })
                }
            ]
        },
        {
            path: 'receipt',
            name: 'Recibos',
            redirect: { name: 'Mis Recibos Pendientes' },
            children: [
                {
                    name: 'Mis Recibos Pendientes',
                    path: 'list',
                    component: useBrandComponent('views/private/receipt/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        searchInput: route.query.searchInput || '',
                        filterRageDatesReceipt: route.query.filterRageDatesReceipt || ''
                    }),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_pending_tickets' }
                }
            ]
        },
        {
            path: 'renovation',
            name: 'Renovaciones',
            redirect: { name: 'Mis Renovaciones' },
            children: [
                {
                    name: 'Mis Renovaciones',
                    path: 'list',
                    component: () => import('@/views/private/renovation/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        searchInput: route.query.searchInput || '',
                        filterRageDatesRenovation: route.query.filterRageDatesRenovation || '',
                        auto_renewed: route.query.auto_renewed || '',
                        subcategory_id: route.query.subcategory_id || '',
                        category_type: route.query.category_type || ''
                    }),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'my_renovations' }
                }
            ]
        },
        {
            path: 'insurance',
            name: 'Aseguradoras',
            redirect: { name: 'Mis Claves de Agente' },
            children: [
                {
                    name: 'Mis Claves de Agente',
                    path: 'list',
                    component: () => import('@/views/private/insurance/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        searchInput: route.query.searchInput || ''
                    }),
                    meta: { requiresPermission: 'brokerin', minLevel: 20 }
                },
                {
                    name: 'Configuración Aseguradora',
                    path: 'config/:insurance_id',
                    component: () => import('@/views/private/insurance/Edit.vue'),
                    meta: { requiresPermission: 'brokerin', minLevel: 20 }
                }
            ]
        },
        {
            path: 'support',
            name: 'Soporte',
            redirect: { name: 'Tickets de Soporte' },
            children: [
                {
                    name: 'Tickets de Soporte',
                    path: 'list',
                    component: () => import('@/views/private/support/List.vue'),
                    props: (route: RouteLocationNormalizedLoaded) => ({
                        searchInput: route.query.searchInput || ''
                    }),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'support' }
                },
                {
                    name: 'Editar Ticket',
                    path: 'config/:hash',
                    component: () => import('@/views/private/support/Edit.vue'),
                    meta: { requiresPermission: 'brokerin', minLevel: 20, requiresSystemPermission: 'support' }
                }
            ]
        },
        {
            path: 'folders',
            name: 'Folders',
            redirect: { name: 'Folders List' },
            children: [
                {
                    name: 'Folders List',
                    path: 'list',
                    component: () => import('@/views/private/folders/Folders.vue'),
                    meta: { requiresPermission: 'brokerin', minLevel: 20 }
                }
            ]
        },
        {
            name: 'error',
            path: 'error',
            redirect: { name: 'noExecutive' },
            children: [
                {
                    name: 'noExecutive',
                    path: 'no-executive',
                    component: () => import('@/views/private/error/NoExecutive.vue')
                }
            ]
        },
        // Rutas de tutoriales
        ...tutorialsRoutes,
        {
            path: 'without_permissions',
            name: 'NoPermissions',
            component: () => import('@/views/private/error/NoPermissions.vue')
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'ErrorPage',
            component: () => import('@/views/private/error/NoPermissions.vue')
        }
    ]
};

export default MainRoutes;
